import { Editor } from '@tinymce/tinymce-react'
import { useTinyMCEUploadHandler } from '../hooks/useTinyMCEUploadHandler'

type TinyRichEditorProps = {
  handleInputChange: (inputName: string, value: any) => void
  value: string
  uploadURL: string
}

function TinyRichEditor({ handleInputChange, value, uploadURL }: TinyRichEditorProps) {
  const { imageUploadHandler } = useTinyMCEUploadHandler({ uploadURL })

  return (
    <Editor
      apiKey="8q7dwlyjsykn5l4scxhhx07jspv5g0mxrs1tsoipl0pnbb9j"
      value={value}
      init={{
        directionality: 'ltr',
        height: 500,
        menubar: 'insert',
        plugins: ['advlist autolink lists link image', 'charmap print preview anchor help', 'searchreplace visualblocks code', 'insertdatetime media table paste wordcount'],
        toolbar:
          'undo redo | formatselect | bold italic | \
                    alignleft aligncenter alignright | \
                    bullist numlist outdent indent | link unlink image | code | help',
        language: 'es',
        paste_data_images: true,
        images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp',
        images_upload_handler: imageUploadHandler
      }}
      onEditorChange={newContent => handleInputChange('content', newContent)}
    />
  )
}

export default TinyRichEditor
